import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';
import { parseISO,  format } from 'date-fns';

import config from '../config/config';

// const apiMealEndpoint = '/api/meal/';
const apiToken = process.env.REACT_APP_API_TOKEN;
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/meetings?secret_key=${apiToken}`);
	
const slice = createSlice({
  name: 'eventeating',
  initialState: {
    list: [],
  },
  reducers: {
    
    eventeatingReceived: (eventeating, action) => {
      // eventeating.list = action.payload.data;
      eventeating.list = [];
      
      action.payload.data.forEach(m => {
        eventeating.list.unshift({
          id: m.id,
          date: format(parseISO(m.date),'dd.MM.yyyy'),
          eventId: m.event_id,
          meetingId: m.meeting_id,
          eatingId: m.eating_id,
          meals: m.meals.map(m => config.defaultMealMapping[m] ? config.defaultMealMapping[m]  : m ),
        });
      });
    },

    // mealAdded: (meal, action) => {
    //   // console.log('mealAdded',meal, action);
    //   meal.list.push({
    //     ...action.payload.params.meal,
    //     id: action.payload.data.id        
    //   });
    // },

    eventeatingmealAdded: (eventeating, action) => {
      // console.log('mealComboAdded',meal, action);
      const {mealId, eventeatingId } = action.payload.params
      const index = eventeating.list.findIndex(m => m.id === eventeatingId);
      // console.log('index',index);
      eventeating.list[index].meals.push(mealId)

    },

    eventeatingmealDeleted: (eventeating, action) => {
      // console.log('mealComboDeleted',meal, action);
      const {mealId, eventeatingId } = action.payload.params
      const index = eventeating.list.findIndex(m => m.id === eventeatingId);
      eventeating.list[index].meals = eventeating.list[index].meals.filter(n => n !== mealId)
    },

    // mealChanged: (meal, action) => {
    //   // console.log('mealAdded',meal, action);
    //   const {meal: newMeal} = action.payload.params
    //   const index = meal.list.findIndex(m => m.id === newMeal.id);
    //   meal.list[index] = newMeal;

    //   // meal.list.push({
    //   //   ...action.payload.params.meal,
    //   //   id: action.payload.data.id        
    //   // });
    // },

    // mealDeleted: (meal, action) => {
    //   meal.list = meal.list.filter(n => n.id !== action.payload.params.mealId)
    // },


  }
});

const { eventeatingReceived, eventeatingmealAdded, eventeatingmealDeleted } = slice.actions;
export default slice.reducer;

// Action Creators
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/meetings?secret_key=${apiToken}`);

export const loadEventeating = () => async (dispatch, getState) => {
  const eventId = config.eventId
  return await dispatch(
    apiCallBegan({
      url: `/api/meal/eventeating/${eventId}?secret_key=${apiToken}`,
      onSuccess: eventeatingReceived.type,
      actionName: 'loadEventeating',
    })
  );
};


export const addEventeatingMeal = ({mealId, eventeatingId}) =>
  apiCallBegan({
    url: `/api/meal/eventeatingmeal/?secret_key=${apiToken}`,
    method: 'post',
    data: { mealId, eventeatingId },
    onSuccess: eventeatingmealAdded.type,
    actionName: 'addEventeatingMeal',
    params: { mealId, eventeatingId }
  });


  export const deleteEventeatingMeal = ({mealId, eventeatingId}) =>
  apiCallBegan({
    url: `/api/meal/eventeatingmeal/${mealId}/${eventeatingId}/?secret_key=${apiToken}`,
    method: 'delete',
    onSuccess: eventeatingmealDeleted.type,
    actionName: 'deleteEventeatingMeal',
    params: { mealId, eventeatingId }
  });


//   export const changeMeal = meal =>
//   apiCallBegan({
//     url: `/api/meal/?secret_key=${apiToken}`,
//     method: 'put',
//     data: {  meal },
//     onSuccess: mealChanged.type,
//     actionName: 'changeMeal',
//     params: { meal }
//   });


//   export const delMeal = mealId =>
//   apiCallBegan({
//     url: `/api/meal/${mealId}/?secret_key=${apiToken}`,
//     method: 'delete',
//     onSuccess: mealDeleted.type,
//     actionName: 'delMeal',
//     params: { mealId }
//   });


//   export const addMealCombo = ({mealId, comboId}) =>
//   apiCallBegan({
//     url: `/api/meal/combo/?secret_key=${apiToken}`,
//     method: 'post',
//     data: {  mealId, comboId },
//     onSuccess: mealComboAdded.type,
//     actionName: 'addMealCombo',
//     params: { mealId, comboId }
//   });

//   export const deleteMealCombo = ({mealComboId,comboId}) =>
//   apiCallBegan({
//     url: `/api/meal/combo/${mealComboId}/?secret_key=${apiToken}`,
//     method: 'delete',
//     onSuccess: mealComboDeleted.type,
//     actionName: 'deleteMealCombo',
//     params: { mealComboId,comboId }
//   });


  

// Selectors

export const getEventeatingSelector = createSelector(
  state => state.entities.eventeating.list,
  eventeating => eventeating
);

export const getEventeatingByDateSelector = (dateStr) =>
  createSelector(
    state => state.entities.eventeating.list,
    eventeating => eventeating.filter(e => e.date === dateStr )
  );

  export const getEventeatingByDateAndEatingSelector = (meetingId, dateStr, eatingId) =>
  createSelector(
    state => state.entities.eventeating.list,
    eventeating => eventeating.filter(e => e.date === dateStr && e.meetingId === meetingId && e.eatingId === eatingId)[0]
  );
// Helpers methods

